import React from "react";

// components
import ReactQuill from "react-quill";

// styles and version
import "react-quill/dist/quill.snow.css";

type IRichText = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  label?: string;
};

const RichText: React.FC<IRichText> = ({
  value,
  placeholder,
  onChange,
  label,
}) => {
  return (
    <div id="editor" className="w-full h-auto mb-6">
      {label && (
        <div className="text-md tracking-wider mb-2 font-semibold">{label}</div>
      )}
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        className="!h-[200px]"
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichText;
